import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { filterUndefined } from '@adeo/ngx-kozikaza-api';

@Injectable({
  providedIn: 'root'
})
export class ModalViewService {

  private _showCloseButton$: BehaviorSubject<boolean> = new BehaviorSubject(true);

  private _closeButtonClicked$: Subject<boolean> = new Subject();

  constructor() {
  }

  public showCloseButton(show: boolean): void {
    this._showCloseButton$.next(show);
  }

  public get showCloseButton$(): Observable<boolean> {
    return this._showCloseButton$.asObservable();
  }

  public closeButtonClicked(): void {
    this._closeButtonClicked$.next(true);
  }

  public get closeButtonClicked$(): Observable<boolean> {
    return this._closeButtonClicked$.asObservable().pipe(filterUndefined());
  }
}
